import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ActivitesSaisies } from '../../../models/heures-saisies.model';
import { NetworkProvider, NetworkStatus } from '../../../providers/network/network';
import { Observable, Subscription } from 'rxjs';
import { GaugeBarComponent, GaugeBarData } from '../../../design-system/gauge-bar/gauge-bar.component';
import { HeuresSaisiesService } from './heures-saisies-service';
import { Router } from '@angular/router';
import { State } from '../../../models/state.model';
import { CrListPage, segmentsViewEnum } from '../../../../mnt/cr/cr-list/cr-list.page';
import moment from 'moment';
import { MenuService, MenuTitle } from '../../../providers/menu.service';

@Component({
  selector: 'heures-saisies-widget',
  templateUrl: 'heures-saisies-widget.component.html',
  styleUrls: ['heures-saisies-widget.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, GaugeBarComponent],
})
export class HeuresSaisiesWidgetComponent implements OnInit {
  @Input() resetSubject: Observable<boolean> = new Observable<boolean>();

  networkStatusSubject: Subscription = null;
  isOnline: boolean = true;
  allStates = State;
  state: State = State.LOADING;
  dataHeuresSaisies: ActivitesSaisies;
  timeTitleDisplay: String;

  gaugeData: GaugeBarData[] = [];

  constructor(
    private router: Router,
    private heuresSaisiesService: HeuresSaisiesService,
    private networkProvider: NetworkProvider,
    private menuService: MenuService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.startCheckConnection();
    await this.refresh();
    this.resetSubject.subscribe((response) => {
      if (response) {
        this.refresh();
      }
    });
  }

  private async startCheckConnection() {
    this.networkStatusSubject = this.networkProvider.networkStatusSubject.subscribe((networkStatus) => {
      let oldIsOnline = this.isOnline;
      this.isOnline = networkStatus === NetworkStatus.ONLINE;
      if (!oldIsOnline && this.isOnline) {
        this.refresh();
      }
    });
  }

  async refresh() {
    if (!this.isOnline) {
      this.state = State.ERROR;
      this.calculDisplayHeuresTotales();
      return;
    }

    let startOfWeek = moment().startOf('week').toISOString();
    let endOfWeek = moment().endOf('week').toISOString();
    this.heuresSaisiesService
      .chargerDonnesHeuresSaisies(startOfWeek, endOfWeek)
      .then((data) => {
        this.dataHeuresSaisies = data;
        this.gaugeData = this.heuresSaisiesService.mapToGaugeData(this.dataHeuresSaisies);
        this.state = State.SUCCESS;
        this.calculDisplayHeuresTotales();
      })
      .catch((err) => {
        this.state = State.ERROR;
        console.error('Erreur chargerDonnesHeuresSaisies', err);
        this.calculDisplayHeuresTotales();
      });
  }

  calculDisplayHeuresTotales(): void {
    if (this.state === State.SUCCESS) {
      let minutes = Math.abs(this.dataHeuresSaisies.temps_total);
      const hours = Math.floor(minutes / 60);
      const formattedHours = hours.toString().padStart(2, '0');
      const mins = minutes % 60;
      const formattedMins = mins.toString().padStart(2, '0');
      this.timeTitleDisplay = `(${formattedHours}h${formattedMins})`;
    }
  }

  async voirDetails(): Promise<void> {
    this.menuService.desactive(MenuTitle.Cr);
    //
    this.router.navigate(['/mnt/crs'], {
      queryParams: {
        segments: segmentsViewEnum.WEEK,
      },
    });
  }
}
